import React, { useState } from 'react';
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Import the logo image
import '../styles/Navbar.css';

const NavbarComponent = () => {
  // Add state to track navbar expanded status
  const [expanded, setExpanded] = useState(false);

  // Add scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ 
      top: 0,
      behavior: 'smooth'
    });
  };

  // Custom Link component that scrolls to top on click
  const ScrollLink = React.forwardRef(({ onClick, to, children, ...rest }, ref) => {
    const handleClick = (e) => {
      if (onClick) onClick(e);
      scrollToTop();
      setExpanded(false); // Close navbar after clicking
    };

    return (
      <Link to={to} {...rest} onClick={handleClick} ref={ref}>
        {children}
      </Link>
    );
  });

  // Enhanced nested dropdown component that supports multiple levels
  const NestedDropdown = ({ title, id, children, level = 1 }) => {
    const [show, setShow] = useState(false);
    
    return (
      <NavDropdown.Item 
        className={`dropdown-item-with-submenu level-${level}`}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        <span>{title} <i className="fa fa-caret-right submenu-arrow"></i></span>
        <div className={`submenu level-${level} ${show ? 'show' : ''}`}>
          {children}
        </div>
      </NavDropdown.Item>
    );
  };

  // Component for sub-nested dropdowns (for deeper nesting)
  const SubNestedDropdown = ({ title, id, children }) => {
    const [show, setShow] = useState(false);
    
    return (
      <div 
        className="dropdown-item-with-submenu sub-nested"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        <span>{title}</span>
        <div className={`submenu sub-level ${show ? 'show' : ''}`}>
          {children}
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar bg="white" expand="lg" className="py-3 shadow-sm" fixed="top" expanded={expanded} onToggle={setExpanded}>
        <Container fluid>
          <Navbar.Brand as={ScrollLink} to="/" className="fw-bold fs-4 d-flex align-items-center ps-0">
            <img
              src={logo}
              alt="ValueCraft Logo"
              height="35"
              style={{ objectFit: 'contain' }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto align-items-center">
              <NavDropdown title="Features" id="products-dropdown">
                <NestedDropdown title="Dashboard" id="crm-subdropdown">
                  <NavDropdown.Item>Real-time Data</NavDropdown.Item>
                  <NavDropdown.Item>Customizable Views</NavDropdown.Item>
                  <NavDropdown.Item>Comprehensive Summary</NavDropdown.Item>
                </NestedDropdown> 
                <NestedDropdown title="Product Development Center" id="hr-subdropdown">
                  <NavDropdown.Item>Style management</NavDropdown.Item>
                  <NavDropdown.Item>BOM creation</NavDropdown.Item>
                  <NavDropdown.Item>Color and size</NavDropdown.Item>
                  <NavDropdown.Item>Combo and marks</NavDropdown.Item>
                  <NavDropdown.Item>Cost estimation</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Merchandising" id="hr-subdropdown">
                  <NavDropdown.Item>Item creation</NavDropdown.Item>
                  <NavDropdown.Item>Purchase orders</NavDropdown.Item>
                  <NavDropdown.Item>Material allocation</NavDropdown.Item>
                  <NavDropdown.Item>Sales and producton orders</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Finance management" id="hr-subdropdown">
                  <SubNestedDropdown title="Admin functions" id="cutting-plans-subdropdown">
                    <NavDropdown.Item>Create items, currencies, and suppliers</NavDropdown.Item>
                    <NavDropdown.Item>Set up company plants.</NavDropdown.Item>
                  </SubNestedDropdown>
                  <NavDropdown.Item>Stock control</NavDropdown.Item>
                  <NavDropdown.Item>Transaction overview</NavDropdown.Item>
                  <NavDropdown.Item>Customization</NavDropdown.Item>
                </NestedDropdown>
               
                <NestedDropdown title="Warehouse management" id="hr-subdropdown">
                  <NavDropdown.Item>GRN (Goods Received Note)</NavDropdown.Item>
                  <NavDropdown.Item>Issuing note</NavDropdown.Item>
                  <NavDropdown.Item>Return notes</NavDropdown.Item>
                  <NavDropdown.Item>Sub PO</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Cutting" id="cutting-subdropdown">
                  <SubNestedDropdown title="Cutting plans" id="cutting-plans-subdropdown">
                    <NavDropdown.Item>Material planning</NavDropdown.Item>
                    <NavDropdown.Item>layar optimization</NavDropdown.Item>
                    <NavDropdown.Item>Cutting execution</NavDropdown.Item>
                    <NavDropdown.Item>Performance tracking</NavDropdown.Item>
                    <NavDropdown.Item>Warehouse stock</NavDropdown.Item>
                    <NavDropdown.Item>Cutting stock</NavDropdown.Item>
                    <NavDropdown.Item>Customized reports</NavDropdown.Item>
                  </SubNestedDropdown>
                  <SubNestedDropdown title="RFID Technology" id="cutting-reports-subdropdown">
                    <NavDropdown.Item>Create bundle sheet</NavDropdown.Item>
                    <NavDropdown.Item>Cut out management</NavDropdown.Item>
                    <NavDropdown.Item>Create bundle Tag</NavDropdown.Item>
                    <NavDropdown.Item>Access control</NavDropdown.Item>

                  </SubNestedDropdown>
                  

                </NestedDropdown>
                <NestedDropdown title="Streamlining embellishment processes" id="hr-subdropdown">
                  <NavDropdown.Item>Create embellishment note & view list</NavDropdown.Item>
                  <NavDropdown.Item>Create embellishment bundle sheet</NavDropdown.Item>
                  <NavDropdown.Item>Create tag</NavDropdown.Item>
                  <NavDropdown.Item>Received (GRN)</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Advanced production tracking system" id="hr-subdropdown">
                  <NavDropdown.Item>Sewing in (Production line)</NavDropdown.Item>
                  <NavDropdown.Item>Sewing out (Production line)</NavDropdown.Item>
                  <NavDropdown.Item>Quality information</NavDropdown.Item>
                  <NavDropdown.Item>FG Rcvd (Finished Goods Received)</NavDropdown.Item>
                  <NavDropdown.Item>FG plant issuing (To Bostock)</NavDropdown.Item>

                </NestedDropdown>

                <NestedDropdown title="Bundle Tracking System" id="hr-subdropdown">
                  <NavDropdown.Item>QR code can</NavDropdown.Item>
                  <NavDropdown.Item>Bundle verification</NavDropdown.Item>
                  <NavDropdown.Item>Movement tracking</NavDropdown.Item>
                  <NavDropdown.Item>Data integration</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Efficient finished goods management" id="hr-subdropdown">
                  <NavDropdown.Item>Plant finished goods stock</NavDropdown.Item>
                  <NavDropdown.Item>FG stock plant out</NavDropdown.Item>
                  <NavDropdown.Item>Bostock received (GRN)</NavDropdown.Item>
                  <NavDropdown.Item>FG sale (PGI)</NavDropdown.Item>
                  <NavDropdown.Item>Bostock (Stock)</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Administration" id="hr-subdropdown">
                  <NavDropdown.Item>Settings</NavDropdown.Item>
                  <NavDropdown.Item>User and data management</NavDropdown.Item>
                </NestedDropdown>

                <NestedDropdown title="Approval Workflow management" id="hr-subdropdown">
                  <NavDropdown.Item>PO approve</NavDropdown.Item>
                  <NavDropdown.Item>Style approve</NavDropdown.Item>
                  <NavDropdown.Item>Item approve</NavDropdown.Item>
                </NestedDropdown>

              </NavDropdown>
              
              <NavDropdown title="Industries" id="industries-dropdown">
                <NavDropdown.Item>Manufacturing</NavDropdown.Item>
                <NavDropdown.Item>Retail</NavDropdown.Item>
                
              </NavDropdown>
              
              <NavDropdown title="Our Services" id="services-dropdown">
                <NavDropdown.Item>Consulting</NavDropdown.Item>
                <NavDropdown.Item>Implementation</NavDropdown.Item>
                <NavDropdown.Item >Support services</NavDropdown.Item>
                <NavDropdown.Item >Training & education</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={ScrollLink} to="/resources">Resources</Nav.Link>

              
              <Nav.Link as={ScrollLink} to="/about">About Us</Nav.Link>
              
              <div className="ms-lg-3 mt-3 mt-lg-0">
                <a href="https://login.valuecraftresourceplanning.com/login" className="text-decoration-none pe-0" onClick={() => {
                  setExpanded(false);
                }}>
                  <Button variant="outline-primary" className="py-1 px-3">Login</Button>
                </a>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Add spacer to prevent content from hiding under the navbar */}
      <div style={{ paddingTop: "76px" }}></div>
    </>
  );
};

export default NavbarComponent;
